import React, { useState } from 'react'
import MasterPage from "../../../EstruturaAntiga/masterpages/simpleAuthenticated"
import { useAuth } from 'context/AuthContext';
import TermoDeAceite from '../Visualizacao';
import CardTermosDeAceite from './Components/TermosDeAceite';
import { Redirect } from 'react-router-dom';

const ListagemTermosDeAceite = () => {
    const {termosAceite} = useAuth();
    const [termoAceitoSelecionado, setTermoAceiteSelecionado] = useState(null)

    if (termosAceite.length === 0) {
        return <Redirect to="/dashboard" />;
    }

    if(termoAceitoSelecionado != null){
        return <TermoDeAceite termo={termosAceite.find(x=>x.id == termoAceitoSelecionado)} selecionarTermo={setTermoAceiteSelecionado}/>
    }

    return(
        <MasterPage>
            <h1>Termos de aceite</h1>
            <div className="container-termos">
                { termosAceite.map( (el) => <CardTermosDeAceite key={ el.id } title={ el.titulo } id={ el.id } selecionarTermo={setTermoAceiteSelecionado}/> ) }
            </div>
        </MasterPage>
    )
}

export default ListagemTermosDeAceite;